import { useEffect, useMemo, useRef } from "react";
import { useAuth } from "@clerk/react";
import { useLocation, useNavigate } from "react-router-dom";
import { makeApi } from "@/lib/api";

const OPEN = ["/subscription-expired", "/pricing", "/payment", "/sign-in", "/sign-up", "/privacy", "/terms", "/home"];
const isOpen = (p) => p === "/" || OPEN.some((o) => p === o || p.startsWith(`${o}/`));

export default function BillingGuard() {
  const { isSignedIn, getToken } = useAuth();
  const api = useMemo(() => makeApi(getToken), [getToken]);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const last = useRef({ at: 0, state: null });

  useEffect(() => {
    if (!isSignedIn) return;
    const apply = (state) => {
      if (state === "expired" && !isOpen(pathname)) navigate("/subscription-expired", { replace: true });
      if (state !== "expired" && pathname === "/subscription-expired") navigate("/dashboard", { replace: true });
    };
    const fresh = last.current.state !== "expired" && Date.now() - last.current.at < 30000;
    if (fresh) {
      apply(last.current.state);
      return;
    }
    api.get("/billing/status").then(({ data }) => {
      last.current = { at: Date.now(), state: data.state };
      apply(data.state);
    }).catch(() => {});
  }, [isSignedIn, pathname, api, navigate]);

  return null;
}
